var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/Logo
 */
import Control from './Control';
import MapControls from './MapControls';
/**
 * @classdesc
 * Class for internal purposes. It shows map attributions.
 * @constructor
 * @extends {Control}
 * @api
 */
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        var _this = this;
        var element = document.createElement('div');
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.Logo',
            name: MapControls.LOGO,
        }) || this;
        var year = new Date().getFullYear();
        /**
         * @private
         * @const
         * @type {string}
         */
        _this.DEFAULT_CONTENT_ = "\n     <div class=\"static\">\n       <span>Cercalia - Data: </span>\n       <a href=\"https://www.cercalia.com\" target=\"_blank\">Cercalia, </a>\n       <a href=\"https://www.tomtom.com\" target=\"_blank\">TomTom, </a>\n       <a href=\"https://www.openstreetmap.org\" target=\"_blank\">OpenStreetMap, </a>\n       <a href=\"https://www.openmaptiles.org\" target=\"_blank\">OpenMapTiles, </a>\n       <a href=\"https://www.naturalearthdata.com\" target=\"_blank\">Natural Earth</a>\n       <a href=\"https://www.rainviewer.com/api.html\" target=\"_blank\">Rain Viewer</a>\n       <span>- ".concat(year, "</span>\n     </div>\n     <div class=\"custom\"></div>\n    ");
        /**
         * @private
         * @type {Element}
         */
        _this.element_ = element;
        _this.element_.className = 'cercalia-logo';
        _this.element_.innerHTML = _this.DEFAULT_CONTENT_;
        return _this;
    }
    /**
     * Change attribution content
     * @param {string} content Content in HTML string
     * @api
     */
    Logo.prototype.setAttribution = function (content) {
        this.element_.querySelector('.custom').innerHTML = content;
    };
    /**
     * @api
     */
    Logo.prototype.restoreDefault = function () {
        this.element_.innerHTML = this.DEFAULT_CONTENT_;
    };
    return Logo;
}(Control));
export default Logo;
//# sourceMappingURL=Logo.js.map